import { createIcon } from '@chakra-ui/react'

export const SendIcon = createIcon({
  displayName: 'Send',
  path: (
    <path
      d='M12.2895 21.0697C13.0587 21.8389 14.3682 21.5327 14.7165 20.5021L19.4689 6.43908C19.8559 5.29388 18.7694 4.19835 17.621 4.57588L3.46086 9.23116C2.42241 9.57256 2.10877 10.889 2.88173 11.662L5.60193 14.3822C6.10191 14.8822 6.88741 14.9543 7.47012 14.5538L12.6289 11.0081C12.8996 10.822 13.2249 11.1535 13.0337 11.4206L9.42214 16.467C9.00451 17.0506 9.07035 17.8506 9.57777 18.358L12.2895 21.0697Z'
      fill='currentColor'
    />
  ),
  viewBox: '0 0 24 24',
})
